
import create from '../utils/create-basic';

export default create({
  render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { class: [_vm.b(), { 'van-hairline--top-bottom': _vm.border }] }, [_vm._t("default")], 2);
  },

  name: 'cell-group',

  props: {
    border: {
      type: Boolean,
      default: true
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/cell-group/index.js
// module id = 72
// module chunks = 39